import { render, staticRenderFns } from "./SensorMsgDetails.vue?vue&type=template&id=ec021b4e&scoped=true&"
import script from "./SensorMsgDetails.vue?vue&type=script&lang=js&"
export * from "./SensorMsgDetails.vue?vue&type=script&lang=js&"
import style0 from "./SensorMsgDetails.vue?vue&type=style&index=0&id=ec021b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec021b4e",
  null
  
)

export default component.exports